export default "__VITE_ASSET__CAtpAqtB__"